export default theme => ({
    createFolderFab: {
        position: 'fixed',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
    },
    createFolderIcon: {
        fontSize: 32,
    },
});